// react core
import { useContext, useState, useEffect } from "react";

// date handling
import dayjs from "dayjs";

// material design
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

// entzy config models and components
import configEntzy from "components/config/ConfigEntzy";
import { MainContext } from "components/main/MainContext";
import { TextTag } from "components/utils/common/CommonTags";
// import { ActionBoxButton } from "components/utils/common/CommonButtons";
// import { ActionLoader } from "components/utils/common/CommonLoaders";
import { parseEntzyUrlComponents } from "models/Tools";
import { UserAvatar } from "components/utils/common/CommonAvatars";

// entzy components
import MemberMessagingSettings from "components/member/MemberMessagingSettings";
// import MemberContacts from "components/members/MemberContacts";

// fonts and colors
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell as iconNotifications } from "@fortawesome/pro-duotone-svg-icons";
// import { faPlus as iconNew } from "@fortawesome/pro-regular-svg-icons";
import { faEllipsisV as iconExpand } from "@fortawesome/pro-regular-svg-icons";
import { faExternalLinkAlt as iconOpen } from "@fortawesome/pro-solid-svg-icons";

function MemberMessagingSelector(props) {
  const mainContext = useContext(MainContext);
  const user = props.user;
  const roomArea = props.roomArea;
  const roomName = props.roomName;
  const roomId = props.roomId;

  const memberName = props.memberName ? props.memberName.toLowerCase() : "";
  const memberUserId = roomId
    .replace(user.identity, "")
    .replace("|", "")
    .replace(":main", "");
  const memberUserDetails =
    mainContext.state.interaction.users.find((u) => u.name === memberName) ||
    {};
  const memberUserTribe = memberUserDetails.tribe || {};

  const searchResultsKey = `connections-${memberName}`;

  const notificationsActive =
    mainContext.state.memberMessaging[roomId] &&
    mainContext.state.memberMessaging[roomId].settingsHydrated &&
    user.name !== memberName &&
    (mainContext.state.memberMessaging[roomId].settingsData.mail ||
      mainContext.state.memberMessaging[roomId].settingsData.push);

  const isAiRoom = roomName && roomName.startsWith("ai");

  const memberBlocked = mainContext.state.contactList.data.items.find(
    (item) => item.User?.name === memberName && item.ChatSettings.blocked
  )
    ? true
    : false;

  const eventuatorCount =
    mainContext.state.search.results[searchResultsKey]?.data?.items?.length ||
    0;
  const eventuatorItems =
    mainContext.state.search.results[searchResultsKey]?.data?.items || [];

  // const mockedEventuatorItems = [
  //   {
  //     event: {
  //       EventId: "39045c8b-d29f-4a2a-8570-8aa991720d2a",
  //       EventTagline: "Cozy retro event space available on the river",
  //       EventCountry: "ch",
  //       EventCurrency: "chf",
  //       EventUrl: "ch.limmatspace",
  //       EventTriggerQuantity: 10,
  //     },
  //     managers: [
  //       {
  //         ManagerId: "us-east-1:8c22f20c-3187-47cb-bd88-c6d0e74b0f17",
  //         ManagerStatus: "owner",
  //         ManagerUserDetails: {
  //           UserId: "us-east-1:8c22f20c-3187-47cb-bd88-c6d0e74b0f17",
  //           UserName: "janedoe",
  //         },
  //       },
  //     ],
  //     members: [
  //       {
  //         MemberId: "us-east-1:100b982c-313e-4dc9-bf39-f42e3d61df96",
  //         MemberStatus: "listed",
  //         MemberUserDetails: {
  //           UserId: "us-east-1:100b982c-313e-4dc9-bf39-f42e3d61df96",
  //           UserName: "johndoe",
  //         },
  //       },
  //     ],
  //   },
  // ];
  // const eventuatorCount = 1;
  // const eventuatorItems = mockedEventuatorItems;

  // generate user list from message notifications and contacts
  // useEffect(() => {
  //   const userList = [];
  //   if (mainContext.state.notifications.data.messages.length > 0) {
  //     mainContext.state.notifications.data.messages.forEach((message) => {
  //       const messageTitle = message.MessageTitle;
  //       const messageTitleArray = messageTitle.split(" ");
  //       messageTitleArray.forEach((word) => {
  //         if (word.charAt(0) === "@") {
  //           word = word.replace("@", "");
  //           if (!userList.includes(word)) {
  //             userList.push(word);
  //           }
  //         }
  //       });
  //     });
  //     mainContext.state.interaction.users.forEach((contact) => {
  //       if (
  //         contact.identity &&
  //         contact.identity !== user.identity &&
  //         !userList.includes(contact.name)
  //       ) {
  //         userList.push(contact.name);
  //       }
  //     });
  //     setContactList(userList);
  //   }
  // }, [
  //   mainContext.state.notifications.data.messages,
  //   mainContext.state.interaction.users,
  //   user,
  // ]);

  const [expanded, setExpanded] = useState(false);
  // const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // effect to call search service with graphql query on searchEvents
  // generate user list from message notifications
  useEffect(() => {
    const generateMemberEventuators = async () => {
      setLoading(true);
      const response = await mainContext.prepareSearchEventuators({
        SearchText: `@${memberName}`,
        ResultsKey: searchResultsKey,
      });
      if (response.alert) {
        mainContext.updateAlert(response);
      } else {
        mainContext.searchEventuators({
          key: searchResultsKey,
          data: response.data,
        });
      }
      setLoading(false);
      setHydrated(true);
    };
    if (!mainContext.state.alert?.show) {
      if (mainContext.state.search.results[searchResultsKey]) {
        const expires =
          mainContext.state.search.results[searchResultsKey].expires;
        const now = dayjs();
        if (now.isAfter(expires)) {
          if (!loading) {
            generateMemberEventuators();
          }
        }
      } else {
        if (!loading && !hydrated) {
          generateMemberEventuators();
        }
      }
    }
  }, [mainContext, memberName, loading, hydrated, searchResultsKey]);

  return (
    <Box className="box-default">
      {mainContext.state.memberMessaging[roomId] && (
        <Box
          className="box-default shadow-default nooverflow"
          sx={{
            mt: configEntzy.APP_SPACING_MD,
            borderRadius: configEntzy.BORDER_SIZE_XL,
          }}
        >
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            disableGutters={true}
            sx={{
              backgroundColor: memberBlocked ? "#330000" : "black",
              color: "white",
              "&.Mui-expanded": {
                backgroundColor: memberBlocked ? "#330000" : "black",
              },
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <FontAwesomeIcon icon={iconExpand} color="white" fixedWidth />
              }
            >
              <Box className="box-default">
                <Box className="box-default text-left">
                  <TextTag
                    text={
                      <span>
                        <span>Eventuators:</span>
                        <span>&nbsp;</span>
                        <span>{eventuatorCount}</span>
                      </span>
                    }
                    textNoCasing={true}
                    bgColor={eventuatorCount > 0 ? "primary.main" : "white"}
                    color="black"
                    rounded={true}
                    edges={true}
                  />
                  {/* <TextTag
                    text={<span>@{memberName}</span>}
                    bgColor="white"
                    color="black"
                    rounded={true}
                    lower={true}
                    edges={true}
                  /> */}
                  {isAiRoom && (
                    <TextTag
                      text={<span>&nbsp;A\&nbsp;</span>}
                      bgColor="white"
                      color="black"
                      rounded={true}
                    />
                  )}
                  {notificationsActive && user.name !== memberName && (
                    <TextTag
                      text={
                        <span>
                          &nbsp;(&nbsp;
                          <FontAwesomeIcon
                            icon={iconNotifications}
                            className="fa-fw"
                          />
                          &nbsp;)&nbsp;
                        </span>
                      }
                      bgColor="white"
                      color="black"
                      rounded={true}
                    />
                  )}
                  <Box className="box-inline right">
                    <TextTag
                      text={
                        memberBlocked
                          ? "Blocked"
                          : expanded
                          ? "Close"
                          : eventuatorCount > 0
                          ? "Let's meet! Open"
                          : "Open Profile"
                      }
                      textNoCasing={true}
                      bgColor="transparent"
                      color="white"
                      noMask={true}
                    />
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Box
                className="box-default"
                sx={{
                  p: configEntzy.APP_SPACING_SM,
                }}
              >
                <Box className="box-inline">
                  <UserAvatar
                    user={{
                      identity: memberUserId,
                      name: memberName,
                    }}
                    nameHideInfo={true}
                  />
                </Box>
              </Box>
              <Box
                className="box-default"
                sx={{
                  p: configEntzy.APP_SPACING_SM,
                }}
              >
                {memberUserTribe.TribeMemberStatus === "visible" && (
                  <Box className="box-default">
                    <Box className="box-default">
                      {memberUserTribe.TribeMemberAge &&
                        memberUserTribe.TribeMemberAge > 0 &&
                        memberUserTribe.TribeMemberAge < 100 && (
                          <Typography variant="subtitle1">
                            <span>
                              Member age: {memberUserTribe.TribeMemberAge}
                            </span>
                          </Typography>
                        )}
                      <Typography variant="subtitle1">
                        <span>Matching with groups </span>
                        <span>
                          {memberUserTribe.TribeCriteriaAgeMin
                            ? memberUserTribe.TribeCriteriaAgeMin
                            : "any age"}
                        </span>
                        <span> to </span>
                        <span>
                          {memberUserTribe.TribeCriteriaAgeMax
                            ? memberUserTribe.TribeCriteriaAgeMax < 100
                              ? memberUserTribe.TribeCriteriaAgeMax
                              : "any age"
                            : "any age"}
                        </span>
                      </Typography>
                    </Box>
                    <Box className="box-default">
                      {memberUserTribe.TribeMemberTags &&
                        memberUserTribe.TribeMemberTags.split(",")
                          .filter((tag) => tag.trim() !== "none")
                          .map((tag) => (
                            <TextTag
                              key={tag}
                              size="small"
                              text={tag.trim()}
                              bgColor="purple"
                              color="white"
                              rounded={true}
                              edges={true}
                              margin={true}
                            />
                          ))}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box
                className="box-default"
                sx={{
                  px: configEntzy.APP_SPACING_SM,
                  pt: configEntzy.APP_SPACING_MD2X,
                  pb: configEntzy.APP_SPACING_MD2X,
                }}
              >
                <Divider />
              </Box>
              <Box
                className="box-default text-left text-paragraph"
                sx={{
                  px: configEntzy.APP_SPACING_SM,
                  pb: configEntzy.APP_SPACING_MD,
                }}
              >
                <Typography variant="subtitle2" color="primary">
                  Eventuators with @{memberName}
                </Typography>
                <Typography variant="subtitle1">
                  Join an activity together to meet or have a chat to start
                  something new
                </Typography>
              </Box>
              {eventuatorCount === 0 ? (
                <Box
                  className="box-default text-left"
                  sx={{
                    px: configEntzy.APP_SPACING_SM,
                    pb: configEntzy.APP_SPACING_MD2X,
                    opacity: 0.2,
                  }}
                >
                  <Typography variant="subtitle1">
                    <em>No recent eventuator activity</em>
                  </Typography>
                </Box>
              ) : (
                <Box
                  className="box-default"
                  sx={{
                    mb: configEntzy.APP_SPACING_MD,
                  }}
                >
                  {eventuatorItems.map((item) => {
                    const urlComponents = parseEntzyUrlComponents(
                      item.event.EventUrl
                    );
                    return (
                      <Box
                        key={item.event.EventId}
                        className="box-default bg-black-t90 shadow-orange-glow text-left action-pointover"
                        sx={{
                          p: configEntzy.APP_SPACING_MD,
                          mb: configEntzy.APP_SPACING_MD,
                          borderRadius: configEntzy.BORDER_SIZE_XL,
                        }}
                        onClick={() => {
                          window.open(
                            urlComponents.absoluteUrl,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        <Box className="box-default zero-height text-right">
                          <Typography variant="subtitle2">
                            <FontAwesomeIcon
                              icon={iconOpen}
                              color="orange"
                              transform="grow-10"
                            />
                          </Typography>
                        </Box>

                        <Box className="box-default">
                          <Typography variant="subtitle2">
                            <span style={{ color: "orange" }}>
                              {urlComponents.pointer}
                            </span>
                            <span>{urlComponents.name}</span>
                            <span>&nbsp;</span>
                            <span>
                              (
                              {item.managers.find(
                                (manager) =>
                                  manager.ManagerUserDetails.UserName ===
                                  memberName
                              )
                                ? "runner"
                                : "rider"}
                              )
                            </span>
                          </Typography>
                          <Typography variant="subtitle1">
                            <span style={{ color: "gray" }}>
                              {item.event.EventTagline}
                            </span>
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              )}

              <Box
                className="box-default text-left"
                sx={{
                  px: configEntzy.APP_SPACING_SM,
                  pb: configEntzy.APP_SPACING_MD,
                }}
              >
                <Typography variant="subtitle2" color="primary">
                  Your settings for @{memberName}
                </Typography>
              </Box>
              <Box
                className="box-default"
                sx={{
                  mb: configEntzy.APP_SPACING_MD,
                }}
              >
                {
                  // do not show settings for self
                  user.name === memberName ? (
                    <Box
                      className="box-default text-left"
                      sx={{
                        px: configEntzy.APP_SPACING_SM,
                        pb: configEntzy.APP_SPACING_MD2X,
                        opacity: 0.2,
                      }}
                    >
                      <Typography variant="subtitle1">
                        <em>This is your own profile (no notifications)</em>
                      </Typography>
                    </Box>
                  ) : (
                    <MemberMessagingSettings
                      {...props}
                      roomArea={roomArea}
                      roomName={roomName}
                      roomId={roomId}
                      memberName={memberName}
                    />
                  )
                }
              </Box>

              {/* <Box
                className="box-default"
                sx={{
                  mt: configEntzy.APP_SPACING_HL,
                  mb: configEntzy.APP_SPACING_MD,
                  backgroundColor: "#333",
                  borderBottomLeftRadius: configEntzy.BORDER_SIZE_XL,
                  borderBottomRightRadius: configEntzy.BORDER_SIZE_XL,
                }}
              >
                <Box
                  className="box-default text-left"
                  sx={{
                    pt: configEntzy.APP_SPACING_MD,
                    px: configEntzy.APP_SPACING_MD,
                    borderTop: configEntzy.BORDER_DASH_OMD,
                  }}
                >
                  <Box className="box-default half-width">
                    <Typography
                      variant="subtitle2"
                      className="upper-case"
                      color="primary"
                    >
                      Switch Member
                    </Typography>
                  </Box>
                  <Box className="box-default half-width text-right">
                    <TextTag
                      text="Add New"
                      bgColor="primary.main"
                      color="black"
                      rounded={true}
                      edges={true}
                      onClick={() => {
                        props.setMemberName(null);
                        setExpanded(false);
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  className="box-default"
                  sx={{
                    pb: configEntzy.APP_SPACING_SM,
                  }}
                >
                  <MemberContacts
                    {...props}
                    setMemberName={props.setMemberName}
                  />
                </Box>
              </Box> */}
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    </Box>
  );
}

export default MemberMessagingSelector;
